import { getScoreNumberColor } from './score-number-color';

type ScoreRingProps = Readonly<{
  score: number;
  size?: number;
  thickness?: number;
  fontSize?: number;
}>;

export default function ScoreRing({
  score,
  size = 34,
  thickness = 4,
  fontSize
}: ScoreRingProps) {
  const clamped = Math.max(0, Math.min(100, score));
  const color = getScoreNumberColor(clamped);
  const innerSize = size - thickness * 2;

  return (
    <div
      className='flex shrink-0 items-center justify-center rounded-full'
      style={{
        width: size,
        height: size,
        background: `conic-gradient(${color} ${clamped * 3.6}deg, #e5e7eb 0deg)`
      }}
    >
      <div
        className='flex items-center justify-center rounded-full bg-white font-bold'
        style={{
          width: innerSize,
          height: innerSize,
          color,
          fontSize: fontSize ?? Math.round(size * 0.34)
        }}
      >
        {Math.round(clamped)}
      </div>
    </div>
  );
}
